import PropTypes from 'prop-types';
import { useTenantDisplay } from '@cyberint/common-utils';

const formatters = {
  name: (t, id) => t?.name || id,
  id: (t, id) => t?._id || t?.id || id,
  name_with_id: (t, id) => {
    const tid = t?._id || t?.id || id;
    return t?.name && t.name !== tid ? `${t.name} (${tid})` : tid;
  }
};

export const TenantDisplay = ({ customerId, format = 'name', fallback }) => {
  const { tenant } = useTenantDisplay(customerId);
  if (!customerId) return fallback || null;

  if (typeof format === 'function') return format(tenant, customerId) || customerId;
  const formatter = formatters[format] || formatters.name;
  return formatter(tenant, customerId) || customerId;
};

TenantDisplay.propTypes = {
  customerId: PropTypes.string,
  format: PropTypes.oneOfType([PropTypes.oneOf(['name', 'id', 'name_with_id']), PropTypes.func]),
  fallback: PropTypes.node
};
